<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/settings_sub.jpg" />
      <h1 class="">会員サイト利⽤登録解除</h1>
    </div>
    <div id="MailSetting" class="detail-cart my-5 border box-p-20">
      <p class="text-center">現在登録中のメールアドレス：{{ mail }}</p>
      <h2 class="mb-2">
        会員登録解除後もお知らせメールを受け取ることは可能です。
      </h2>
      <h2 class="mb-2 text-left">弊社からのお知らせ</h2>
      <div class="c-radio mb-5">
        <div class="radio_box d-flex">
          <div>
            <input
              type="radio"
              id="unregister01"
              v-model="info"
              value="1"
              class="mt-n1"
            />
            <label for="unregister01">解除する</label>
          </div>
          <div>
            <input
              type="radio"
              id="unregister02"
              v-model="info"
              value="0"
              class="mt-n1"
              checked
            />
            <label for="unregister02">継続受信する</label>
          </div>
        </div>
      </div>
      <h2 class="mb-2 text-left">実績メール</h2>
      <div class="c-radio">
        <div class="radio_box d-flex">
          <div>
            <input
              type="radio"
              id="unregister03"
              v-model="achievement"
              value="1"
              class="mt-n1"
            />
            <label for="unregister03">解除する</label>
          </div>
          <div>
            <input
              type="radio"
              id="unregister04"
              v-model="achievement"
              value="0"
              class="mt-n1"
              checked
            />
            <label for="unregister04">継続受信する</label>
          </div>
        </div>
        <p>
          ※実績メールの配信頻度を変更する場合は、利⽤登録解除を⾏う前に、配信メール変更メニューで設定変更を⾏ってください。
        </p>
      </div>
    </div>
    <div class="my-5 box-p-20">
      <p class="mb-5">
        下にある［会員サイト利⽤登録を解除］ボタンを押すと確認メールが送信されます。<br />確認メール開き、メール本⽂にあるリンク先URLをクリックして解除実⾏ページを開いて「本解除」ボタンを押してください。
      </p>
      <p>
        メールが来ない場合、メールアドレスが間違っているか、迷惑メールフォルダに分類されている可能性があります。<br />メールアドレスが間違っていた場合は、⼤変お⼿数ですが、先に「メールアドレスを変更する」ボタンを押して受信可能なメールアドレスを⼊⼒してください。
      </p>
    </div>
    <div class="my-5 text-center">
      <button class="btn d-inline-block" v-on:click="putData">
        会員サイト利⽤登録を解除する
      </button>
    </div>
    <div class="my-5 text-center">
      <router-link to="/settings/mail" class="btn d-inline-block">メールアドレスを変更する</router-link>
    </div>
    <div class="mb-5 text-center">
      <router-link to="/settings" class="btn d-inline-block"
        >会員情報を変更へ戻る</router-link
      >
    </div>
  </section>
</template>
<script>
import Request from "@/modules/Request";
let request = new Request();

export default {
  data() {
    return {
      mail: "",
      info: "0",
      achievement: "0",
    };
  },
  mounted() {
    this.getCurrentMailAdress();
  },
  methods: {
    getCurrentMailAdress() {
      console.log('getmailadress')
      let requestParams = request.createParams(
        "webMdlMemberInfo",
        "getMailAddress",
        []
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.mail = data.CurrentMailAddress;
        });
    },
    putData() {
      console.log(this.mail)
      let postParams = [this.mail,this.info,this.achievement];
      let requestParams = request.createParams(
        "webMdlMemberInfo",
        "putUnRegister",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          this.$router.push("/settings/unregister/reception");
        });
    },
  },
};
</script>

<style>
.detail-cart div.c-radio div.radio_box div {
  min-width: 20%;
  margin-bottom: 10px;
}
.detail-cart div.c-radio div.radio_box label {
  font-weight: bold;
  cursor: pointer;
  font-size: 1.125em;
}
button.btn.d-inline-block {
  width: 300px;
}
a.btn.d-inline-block {
  width: 260px;
}
</style>
